import React from "react"
import Paper from "@material-ui/core/Paper";
import {withStyles, createStyles, Theme} from '@material-ui/core/styles';
import {WithTranslation, withTranslation} from "react-i18next";
import {compose} from "redux";

type FooterProps = WithTranslation & {
    urlLabel: string;
    classes: any;
}

const styles = ({palette, spacing}: Theme) => createStyles({
    root: {
        backgroundColor: palette.primary.main,
        position: "fixed",
        bottom: "0px",
        width: "100%"
    },
    text: {
        color: palette.primary.contrastText,
        marginLeft: '10px',
        marginRight: '10px'
    },
    link: {
        display: 'block',
        float: 'right',
        color: palette.primary.contrastText
    }
});

class SowFooter extends React.Component<FooterProps> {
    public static defaultProps = {
        urlLabel: "Corporate Information"
    };

    render() {
        return (
            <Paper square className={this.props.classes.root}>
                <div className={this.props.classes.text}>
                    Copyright © 2001-2021 Hama GmbH &amp; Co KG
                    <div className={this.props.classes.link}>
                        <a className={this.props.classes.text} href="https://company.hama.com/"
                           target="_blank">{this.props.t('footer.corporate')}</a>
                    </div>
                </div>
            </Paper>
        )
    }
}

export default compose(
    withTranslation('common'),
    withStyles(styles)
)(SowFooter) as any;